module.exports = __webpack_public_path__ + "img/mission.48f7d9be.jpg";